import { Layout } from 'components/atoms'
import { InputBuild, SelectBuild } from 'components/molecules'
import { FormFinancingProps } from 'pages/Contracts/Components/Forms/FormFinancing/interfaces'
import React, { useMemo } from 'react'
import { useFormContext } from 'react-hook-form'
import { FormContractValue } from './form'
import { ViewContractFormProps } from './interfaces'

const ViewContractForm: React.FC = () => {
    const { register, watch } = useFormContext<{
        contract: ViewContractFormProps
        financing: FormFinancingProps
    }>()

    const form = useMemo(
        () => FormContractValue(watch('contract.ufContrato')),
        [watch('contract.ufContrato')]
    )

    const tipoAditivo = watch('contract.tipoAditivo' as any)


    return (
        <Layout
            full
            type="container"
            display="grid"
            gap={8}
            data-testid="form-container"
        >
            <Layout type="row" gutter={{ y: 1.5 }} data-testid="form-fields">
                {form.map(({ layout, input, select }, key) => (
                    <Layout {...layout} key={key}>
                        {select ? (
                            <SelectBuild
                                {...select}
                                {...register(`contract.${select.id}`)}
                                isDisable={true}
                            />
                        ) : (
                            input && (
                                <InputBuild
                                    {...input}
                                    {...register(`contract.${input.id}`)}
                                    value={
                                        watch(`contract.${input.id}`) as string
                                    }
                                    isDisable={true}
                                />
                            )
                        )}
                    </Layout>
                ))}
                {tipoAditivo && (
                                    <Layout type="col" layout={{ base: 12, md: 4 }}>
                                        <SelectBuild
                                            id="tipoAditivo"
                                            label="Tipo de Aditivo"
                                            optionsType="tipoAditivo"
                                            {...register('contract.tipoAditivo' as any)}
                                            value={tipoAditivo as string}
                                            isDisable={true}
                                        />
                                    </Layout>
                                )}                
                {watch('contract.dataBaixaCancelamento' as any) && (
                    <>
                        <Layout type="col" layout={{ base: 12, md: 4 }}>
                            <InputBuild
                                label="Data Baixa/Cancelamento"
                                id="descricaoBaixaCancelamento"
                                {...register(
                                    'contract.dataBaixaCancelamento' as any
                                )}
                                value={
                                    watch(
                                        'contract.dataBaixaCancelamento' as any
                                    ) as any
                                }
                                isDisable={true}
                            />
                        </Layout>

                        <Layout type="col" layout={{ base: 12, md: 6 }}>
                            <InputBuild
                                label="Motivo Baixa/Cancelamento"
                                id="descricaoBaixaCancelamento"
                                {...register(
                                    'contract.descricaoBaixaCancelamento' as any
                                )}
                                value={
                                    watch(
                                        'contract.descricaoBaixaCancelamento' as any
                                    ) as any
                                }
                                isDisable={true}
                            />
                        </Layout>
                    </>
                )}
            </Layout>
        </Layout>
    )
}

export default ViewContractForm
